import { BannerPromo } from "../components/sections/BannerPromo";
import { Categorias } from "../components/sections/Categorias";
import { ComoPedir } from "../components/sections/ComoPedir";
import { Contato } from "../components/sections/Contato";
import { Galeria } from "../components/sections/Galeria";
import { Hero } from "../components/sections/Hero";
import { MaisVendidos } from "../components/sections/MaisVendidos";
import { SobreNos } from "../components/sections/SobreNos";
import { useTrackActiveSection } from "../context/ActiveSectionContext";
import { NAV_LINKS } from "../data/site";
import { useHashScroll } from "../hooks/useHashScroll";

const SECTION_IDS = NAV_LINKS.flatMap((link) => (link.sectionId ? [link.sectionId] : []));

const Home = () => {
  useTrackActiveSection(SECTION_IDS);
  useHashScroll();

  return (
    <>
      <Hero />
      <Categorias />
      <MaisVendidos />
      <BannerPromo />
      <Galeria />
      <ComoPedir />
      <SobreNos />
      <Contato />
    </>
  );
};

export default Home;
